import { forwardRef } from 'react';

import { IconButton, IconButtonProps } from '@material-ui/core';
import { WithStyles, createStyles, withStyles } from '@material-ui/core/styles';

import { RiPencilFill as Edit } from '@remixicon/react';
import classNames from 'classnames';

const styles = () =>
  createStyles({
    root: {},
  });

export interface SectionEditButtonProps
  extends Omit<IconButtonProps, 'classes'>,
    WithStyles<typeof styles> {}

const SectionEditButtonMui = forwardRef<
  HTMLButtonElement,
  SectionEditButtonProps
>((props, ref) => {
  const { className, classes, ...rest } = props;

  return (
    <IconButton
      ref={ref}
      className={classNames(className, classes.root)}
      size="small"
      data-track-id="button.edit-section"
      data-track-action="open-dialog"
      data-track-source-anchor="7d40e4e7a9;section-edit-button-mui-icon-button;low" {...rest}
    >
      <Edit size="1em" />
    </IconButton>
  );
});

SectionEditButtonMui.displayName = 'SectionMui.EditButton';

/** @deprecated Legacy MUI copy - migrate consumers to the Encore Section and delete. */
export default withStyles(styles)(SectionEditButtonMui);
